import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../../../Assets/css/forgotPassword.css";
import OtpInput from "react-otp-input";
import axios from "axios";
import Loader from "../../../Components/MainLayout/Loader";
import MySnackbar from "../../../Components/MyComponents/MySnackbar";

class ForgotPassword extends Component {
  input = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      clicks: 0,
      otp: "",
      code: "",
      message_id: {},
      formData: { username: "", otp: "", password: "" },
      loading: false,
      snackbar: false,
      isOtpFull: false,
    };
  }

  handleChangeInput = (event) => {
    const { formData } = this.state;
    formData[event.target.name] = event.target.value;
    this.setState({ formData });
  };

  IncrementItem = () => {
    this.setState({ clicks: this.state.clicks + 1 });
  };

  DecreaseItem = () => {
    this.setState({ clicks: this.state.clicks - 1 });
  };

  handleSubmit = (e) => {
    this.setState({ loading: true, snackbar: false });
    e.preventDefault();
    let form_data = new FormData();
    const { formData } = this.state;

    form_data.append("username", formData.username);
    form_data.append("otp", formData.otp);
    form_data.append("password", formData.password);
    form_data.append("message_id", this.state.message_id["message_id"]);

    if (form_data) {
      if (this.state.code === "") {
        axios
          .post(`/api/resetPassword`, form_data, {
            headers: {
              Authorization: "",
            },
          })
          .then((response) => {
            if (response.status === 201 && response.data.id != null) {
              this.setState({
                smsdata: response.data,
                vissible: true,
                message_id: JSON.parse(response.data.data),
                code: response.data.id,
                loading: false,
              });

              this.IncrementItem();
            } else {
              this.setState({
                loading: false,
                snackbar: true,
              });
            }
          });
      } else {
        axios
          .post(`/api/verifyPassword`, form_data, {
            headers: {
              Authorization: "",
            },
          })
          .then((response) => {
            if (response.status === 201) {
              this.IncrementItem();
              this.setState({ loading: false });
            }
            this.props.history.push("/user/login");
          });
      }
    }
  };

  handleChange = (otp) => {
    console.log(otp, otp.length, "otpotp length");
    this.setState({ isOtpFull: false });
    const { formData } = this.state;
    if (otp.length === 6) {
      this.setState({ isOtpFull: true });
    }
    formData["otp"] = otp;
    this.setState({ formData });
    console.log(formData, "formdata");
    // }
  };
  checkOtp = () => {
    this.setState({ isOtpFull: true });
  };
  render() {
    return (
      <div>
        <div className="container">
          <div className="my-3">
            <p className="py-2">
              {this.state.clicks >= 1 ? (
                <div onClick={this.DecreaseItem}>
                  <span className="bg-light py-2 px-3 rounded-lg">
                    <i
                      className="fa fa-chevron-left th-primary"
                      aria-hidden="true"
                    ></i>
                  </span>
                </div>
              ) : (
                <Link to="/login">
                  <span className="bg-light py-2 px-3 rounded-lg">
                    <i
                      className="fa fa-chevron-left th-primary"
                      aria-hidden="true"
                    ></i>
                  </span>
                </Link>
              )}
            </p>
          </div>

          <div className="th-36 th-black pt-2 w-50 py-5">Forgot Password</div>

          {this.state.clicks === 0 ? (
            <p className="th-grey th-14">
              Please input your username to reset your password:
            </p>
          ) : null}
          {this.state.clicks === 1 ? (
            <p className="th-grey th-14">
              Please input the 6 digit OTP sent on your registered mobile
              number.
            </p>
          ) : null}

          {this.state.clicks === 2 ? (
            <p className="th-grey th-12">
              Please set a new password for your account.
            </p>
          ) : null}

          <div className="py-2 ">
            {this.state.clicks === 0 ? (
              <input
                type="text"
                className="form-control th-input-primary"
                placeholder="Username"
                name="username"
                onChange={this.handleChangeInput}
              />
            ) : null}
            {this.state.clicks === 1 ? (
              <div className="w-100">
                <OtpInput
                  value={this.state.formData.otp}
                  onChange={this.handleChange}
                  numInputs={6}
                  separator={<span>-</span>}
                  isInputNum={true}
                  inputStyle={{
                    width: 40,
                    height: 40,
                    borderRadius: 4,
                    outlineStyle: "revert",
                    outline: "none",
                  }}
                />
              </div>
            ) : null}

            {this.state.clicks === 2 ? (
              <input
                type="password"
                className="form-control th-input-primary"
                placeholder="New Password"
                name="password"
                onChange={this.handleChangeInput}
              />
            ) : null}
            <div className="py-3">
              {!this.state.loading ? (
                this.state.clicks >= 3 ? (
                  <p className="text-success text-center th-14">
                    <i className="fa fa-check pr-2" aria-hidden="true"></i>
                    Password Reset Successfully
                  </p>
                ) : this.state.clicks === 1 ? (
                  this.state.isOtpFull ? (
                    <React.Fragment>
                      <button
                        className="th-btn-primary py-2 w-100"
                        onClick={
                          this.state.formData.otp.length > 0
                            ? this.IncrementItem
                            : null
                        }
                      >
                        Submit
                      </button>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <button className="th-btn-primary-disabled py-2 w-100">
                        Submit
                      </button>
                    </React.Fragment>
                  )
                ) : this.state.clicks === 0 ? (
                  <button
                    className="th-btn-primary py-2 w-100"
                    onClick={
                      this.state.formData.username.length > 0
                        ? this.handleSubmit
                        : null
                    }
                  >
                    Submit
                  </button>
                ) : (
                  <button
                    className="th-btn-primary py-2 w-100"
                    onClick={
                      this.state.formData.username.length > 0
                        ? this.handleSubmit
                        : null
                    }
                  >
                    Submit
                  </button>
                )
              ) : (
                <div className="my-1 pr-2 text-center">
                  <Loader />
                </div>
              )}
              {this.state.snackbar ? (
                <MySnackbar title="Username Not Found" />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default ForgotPassword;
